import axios from 'axios';

// Usa la configuración global definida en src/axiosConfig.js
export default axios;